class EventEmitter {
  constructor() {
    this.events = {}; // 存储事件监听器
  }

  // 注册事件监听器
  on(type, listener) {
    if (!this.events[type]) {
      this.events[type] = [];
    }
    this.events[type].push(listener);
  }

  // 移除事件监听器
  off(type, listener) {
    if (!this.events[type]) return;

    this.events[type] = this.events[type].filter((l) => l !== listener);
  }

  // 触发事件，并通过 detail 传递参数
  emit(type, detail) {
    if (!this.events[type]) return;

    const event = { type, detail }; // 模拟事件对象
    this.events[type].forEach((listener) => {
      listener(event); // 将事件对象传递给监听器
    });
  }

  // 注册一次性监听器
  once(type, listener) {
    const wrapper = (event) => {
      listener(event); // 执行监听器
      this.off(type, wrapper); // 移除监听器
    };
    this.on(type, wrapper);
  }
}

// 示例用法
const eventEmitter = new EventEmitter();
export default eventEmitter;
